export default {
    current: (state, getters, rootState, rootGetters) => {
        let panel = {}
        try {
            let track = rootGetters['v4/track/current']
            panel = track.panels.find(p => p.name === rootState.route.params.panels_name) || {}
        }
        catch (e) {}
        return panel
    },
    get: (state, getters, rootState, rootGetters) => (name) => {
        let panel = {}
        try {
            let track = rootGetters['v4/track/current']
            panel = track.panels.find(p => p.name === name) || {}
        }
        catch (e) {}
        return JSON.parse(JSON.stringify(panel))
    },
    getResponse: (state, getters, rootState, rootGetters) => (name, response) => {
        let resp = {}
        try {
            let track = rootGetters['v4/track/current']
            let panel = track.panels.find(p => p.name === name) || {}
            if (['value', 'date'].includes(panel.type)) {
                resp = panel.responses[0]
            }
            else {
                resp = panel.responses.find(r => r.value === response) || {}
            }
        }
        catch (e) {}
        return JSON.parse(JSON.stringify(resp))
    },
    checkResponse: (state, getters, rootState, rootGetters) => (name, response) => {
        let resp = false
        try {
            let track = rootGetters['v4/track/current']
            let panel = track.panels.find(p => p.name === name) || {}
            resp = panel.responses.find(r => r.value === response) || {}
            resp = resp.selected
        }
        catch (e) {}
        return resp
    },
    getSelectedResponses: (state, getters, rootState, rootGetters) => (name) => {
      let resps = []
      try {
        let track = rootGetters['v4/track/current']
        let panel = track.panels.find(p => p.name === name) || {}

        resps = panel.responses.filter(r => r.selected)
      }
      catch (e) {}
      return resps
    },
    getOrder: (state, getters, rootState, rootGetters) => {
        let order = 0
        try {
            const track = rootGetters['v4/track/current']
            const filtered = track.panels.filter(p => !p.computation && !p.skipForStreamlined)
            const indexOfCurrent = filtered.findIndex(p => p.name === rootState.route.params.panels_name) || 0
            const indexOfSummary = filtered.findIndex(p => p.name === 'summary')
            if (indexOfCurrent < indexOfSummary) {
                order = indexOfCurrent/indexOfSummary
            }
            else {
                let postAssessment = filtered.slice(indexOfSummary)
                postAssessment = postAssessment.filter(p => p.view === 'Panel')
                const newIndex = postAssessment.findIndex(p => p.name === rootState.route.params.panels_name) || 0
                order = newIndex/postAssessment.length
            }
        }
        catch (e) {}
        return order*100
    },
}
